<template>
  <div class="task_popover">
    <el-popover
        ref="taskPop"
        placement="right"
        width="280"
        :visible-arrow="false"
        popper-class="popover_card"
        trigger="click">
      <TaskDefaultList :taskList="taskList" :invoke="invoke"></TaskDefaultList>
      <div class="task_list" slot="reference" v-if="taskList != undefined">
        <div class="task_list_item" v-for="(itemTask,indexTask) in taskList"
             :class="{'gray_style':new Date(itemTask.endTimeLong)<new Date(),'hidden':indexTask>2}"
             :title="itemTask.intvStartHourAndMinute+' '+itemTask.intvTitle">
          {{ itemTask.intvStartHourAndMinute }} {{ itemTask.intvTitle }}
        </div>
        <div class="more_ellipsis" v-if="taskList.length>3">...</div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import {utils} from '../common/common'
import TaskDefaultList from "./TaskDefaultList.vue";

export default {
  props: {
    taskList: Array,
    invoke: Function
  },
  components: {
    TaskDefaultList
  },
  watch: {},
  filters: {},
  data() {
    return {}
  },
  mounted() {

  },
  methods: {
    closePop() {
      this.$refs.taskPop.doClose();
    },
    toTaskDetail() {

    }
  }
}
</script>
<style lang="less">
.task_popover {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex-grow: 1;
  flex-shrink: 1;
  cursor: pointer;

  .hidden {
    display: none;
  }

  .task_list {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    flex-grow: 1;

    .task_list_item {
      flex-grow: 1;
      flex-shrink: 1;
      width: 1px;
      border-left: 2px solid #FF991C;
      background: #FFF1D4;
      border-radius: 1px;
      line-height: 42px;
      color: #333333;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      padding-left: 8px;
      height: 40px;
    }

    .more_ellipsis{
      flex-grow: 0;
      flex-shrink: 0;
      height: 40px;
      line-height: 40px;
      padding: 0 5px;
    }

    .gray_style {
      background: #F5F5F5;
      border-left: 2px solid #BBBBBB;
    }
  }
}

.task_popover > span {
  flex-grow: 1;
}

.popover_card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0 !important;


}
</style>